import React from 'react'
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom'
import './global'
 
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { installAxiosErrorNormalizer } from './helpers/api-error'

// Guarantee every failed request surfaces a readable message instead of
// crashing a reducer on `action.payload.error` (undefined) or showing a blank
// toast. Must run before any request fires.
installAxiosErrorNormalizer()

// eslint-disable-next-line
String.prototype.spaceBeforeCap = function () {
  return String(this).toLowerCase().replace(/(^| )(\w)/g, x => x.toUpperCase())
}

// app and admin routes
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <App />
  </Router>
);

serviceWorker.unregister()